import * as helpers from '../../js/helpers';

export default function projectVideo() {
    const videoWrap = document.querySelector('.projects__focus-video');

    if (videoWrap === null) {
        return;
    }

    const video = document.querySelector('.projects__focus-video video');
    const actionsContainer = document.querySelector('.projects__focus-actions');
    const play = actionsContainer.querySelector('.projects__focus-action.-play');
    const pause = actionsContainer.querySelector('.projects__focus-action.-pause');

    // video.play();
    video.addEventListener('ended', () => {
        video.play();
    });

    const managePlayPause = (state) => {
        // reset state
        play.setAttribute('aria-hidden', true);
        pause.setAttribute('aria-hidden', true);
        helpers.removeClass(pause, '-is-active');
        helpers.removeClass(play, '-is-active');

        if (state) {
            pause.setAttribute('aria-hidden', false);
            helpers.addClass(pause, '-is-active');
        } else {
            play.setAttribute('aria-hidden', false);
            helpers.addClass(play, '-is-active');
        }
    };

    managePlayPause(true);

    play.addEventListener('click', () => {
        video.play();
        managePlayPause(false);
    });

    pause.addEventListener('click', () => {
        video.pause();
        managePlayPause(true);
    });
}
